/**
 * Acquista ora → checkout in italiano.
 *
 * Problema: se la sessione/root è /en (o il tema usa Shopify.routes.root
 * su path inglese), il checkout diventa en-it con titoli EN e UI inglese.
 * Qui forziamo locale IT + URL /checkout?locale=it.
 */
(function () {
  var BUY_NOW_SEL = 'xo-cart-add.xo-product-info-content__buy-now-btn';
  var pendingCheckout = false;
  var pendingTimer = 0;
  var redirecting = false;

  function checkoutUrl() {
    return '/checkout?locale=it';
  }

  function setItalianLocale() {
    try {
      var body = new URLSearchParams();
      body.set('form_type', 'localization');
      body.set('utf8', '✓');
      body.set('_method', 'put');
      body.set('locale_code', 'it');
      body.set('country_code', 'IT');
      return fetch('/localization', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
        credentials: 'same-origin',
      }).catch(function () {});
    } catch (e) {
      return Promise.resolve();
    }
  }

  function goCheckout() {
    if (redirecting) return;
    redirecting = true;
    pendingCheckout = false;
    if (pendingTimer) {
      window.clearTimeout(pendingTimer);
      pendingTimer = 0;
    }
    setItalianLocale().finally(function () {
      window.location.href = checkoutUrl();
    });
  }

  function armBuyNow(el) {
    if (!el || el.getAttribute('data-respet-buy-now') === '1') return;
    el.setAttribute('data-respet-buy-now', '1');
    el.setAttribute('xo-checkout-redirection', 'true');
    el.setAttribute('xo-cart-opened', 'false');

    el.addEventListener(
      'click',
      function () {
        if (el.hasAttribute('xo-disabled')) return;
        pendingCheckout = true;
        redirecting = false;
        el.setAttribute('xo-checkout-redirection', 'true');
        el.setAttribute('xo-cart-opened', 'false');

        if (pendingTimer) window.clearTimeout(pendingTimer);
        pendingTimer = window.setTimeout(function () {
          goCheckout();
        }, 2500);
      },
      true
    );
  }

  function scan(root) {
    (root || document).querySelectorAll(BUY_NOW_SEL).forEach(armBuyNow);
  }

  // Il tema fa: location.href = Shopify.routes.root + 'checkout'
  // Se root è /en/, riscriviamo verso checkout IT.
  try {
    var hrefDesc = Object.getOwnPropertyDescriptor(Location.prototype, 'href');
    if (hrefDesc && hrefDesc.set && hrefDesc.get) {
      Object.defineProperty(Location.prototype, 'href', {
        configurable: true,
        enumerable: true,
        get: function () {
          return hrefDesc.get.call(this);
        },
        set: function (value) {
          var next = String(value);
          try {
            var u = new URL(next, window.location.origin);
            var path = u.pathname || '';
            var goesEnCheckout =
              path === '/en/checkout' ||
              path.indexOf('/en/') === 0 && path.indexOf('checkout') !== -1 ||
              (pendingCheckout && (path === '/checkout' || path.indexOf('/checkout') !== -1));
            if (goesEnCheckout || (pendingCheckout && path.indexOf('checkout') !== -1)) {
              next = checkoutUrl();
            }
          } catch (e) {}
          hrefDesc.set.call(this, next);
        },
      });
    }
  } catch (e) {}

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = typeof input === 'string' ? input : input && input.url;
      var isCartAdd = url && String(url).indexOf('/cart/add') !== -1;
      var shouldCheckout = pendingCheckout && isCartAdd;

      return nativeFetch.apply(this, args).then(
        function (response) {
          if (shouldCheckout && response && response.ok) {
            goCheckout();
          } else if (shouldCheckout) {
            pendingCheckout = false;
            if (pendingTimer) {
              window.clearTimeout(pendingTimer);
              pendingTimer = 0;
            }
          }
          return response;
        },
        function (err) {
          if (shouldCheckout) {
            pendingCheckout = false;
            if (pendingTimer) {
              window.clearTimeout(pendingTimer);
              pendingTimer = 0;
            }
          }
          throw err;
        }
      );
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
